export default class riesgoService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/riesgo',
			"id": '/api/riesgo/:id',
			"new": '/api/riesgo',
			'delete': '/api/riesgo/:id'
		};
	}

	getAll(filters){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filters
		};
		return this.http.get(url);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	update(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.put(url, data);
	}

	delete(objId){
		let idRoute = this.routes.delete.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.delete(url);
	}
}


// WEBPACK FOOTER //
// ./app/js/services/riesgoService.js